import { Percent, Wallet, Landmark, TrendingUp, Scale, ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { scrollToId } from "@/lib/scroll";

const TOOLS = [
  { id: "rentabilidad", icon: Percent, title: "Rentabilidad inmobiliaria", desc: "Cálculo instantáneo de rentabilidad bruta y neta descontando IBI, comunidad, seguro y mantenimiento.", badge: "Fórmula real", span: "md:col-span-3" },
  { id: "cash-flow", icon: Wallet, title: "Cash flow", desc: "Flujo de caja neto real mes a mes considerando amortización de hipoteca e imprevistos de vacancia.", badge: "Mensual y anual", span: "md:col-span-3" },
  { id: "hipoteca", icon: Landmark, title: "Hipoteca", desc: "Simulador de financiación a tipo fijo o variable, cuota exacta y LTV óptimo para tu perfil.", badge: "Simulador 2026", span: "md:col-span-2" },
  { id: "roi", icon: TrendingUp, title: "ROI & Cash-on-Cash", desc: "Retorno exacto sobre el capital propio invertido: entrada, impuestos, reforma y gastos.", badge: "Multiplicador de capital", span: "md:col-span-2" },
  { id: "comprar-vs-alquilar", icon: Scale, title: "Comprar vs alquilar", desc: "Comparativa de coste de oportunidad patrimonial a 5, 10 y 20 años vista.", badge: "Análisis de oportunidad", span: "md:col-span-2" },
];

export const ToolsGrid = () => (
  <section id="herramientas" data-testid="tools-grid-section" className="py-16 sm:py-24 lg:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal className="mb-12 max-w-3xl sm:mb-16">
        <p className="mb-3 text-xs font-semibold uppercase tracking-[0.2em] text-emerald-600">Herramientas</p>
        <h2 className="font-display text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">
          Todas las herramientas que necesitas para analizar una inversión
        </h2>
        <p className="mt-4 max-w-2xl text-base text-slate-600 sm:text-lg">
          Cinco motores de cálculo para analizar la rentabilidad, el cash flow y el ROI de cualquier inversión inmobiliaria en España, y decidir con datos: comprar o seguir buscando.
        </p>
      </Reveal>

      <div className="grid grid-cols-1 gap-5 md:grid-cols-6">
        {TOOLS.map((tool, i) => (
          <Reveal key={tool.id} delay={i * 0.07} className={tool.span}>
            <button
              data-testid={`tool-card-${tool.id}`}
              onClick={() => scrollToId("#analisis")}
              className="group flex h-full w-full flex-col rounded-3xl border border-slate-200 bg-white p-7 text-left transition-all duration-300 hover:-translate-y-1 hover:border-emerald-500/30 hover:shadow-xl hover:shadow-emerald-950/5"
            >
              <div className="mb-5 flex items-start justify-between">
                <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-emerald-50 transition-colors duration-300 group-hover:bg-emerald-100">
                  <tool.icon className="h-6 w-6 text-emerald-600" />
                </div>
                <ArrowUpRight className="h-5 w-5 text-slate-300 transition-all duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-emerald-500" />
              </div>
              <h3 className="font-display text-xl font-bold tracking-tight text-slate-900">{tool.title}</h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-slate-600">{tool.desc}</p>
              <span className="mt-5 inline-flex w-fit rounded-full bg-slate-100 px-3 py-1 text-[11px] font-semibold uppercase tracking-wider text-slate-500 transition-colors duration-300 group-hover:bg-emerald-50 group-hover:text-emerald-700">
                {tool.badge}
              </span>
            </button>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
